import React, { useState, useEffect } from "react";
import { Card } from "reactstrap";
import { DefaultPerPageValue } from "../../constants/Common";
import { toast } from "react-toastify";
import NodataFound from "../Common/NoDataFound";
import InfiniteScroll from "react-infinite-scroll-component";
import Loader from "../Common/Loader";
import { getUserList } from "../../api/casp/user";
import { Role } from "../../constants/Role";
import DashboardCardHeader from "./dashboardCardHeader";
import { MemberIcon } from "../../constants/MemberIcon";
import { ucFirst } from "../../helpers/string_helper";
import Member from "../../assets/images/icons/achieve.png";
import UserProfile from "../casp/common/userProfile";
import { withTranslation } from "react-i18next";

function MemberList({ projectId, t }) {
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const [memberList, setMemberList] = useState([]);

  useEffect(() => {
    if (projectId) {
      getMemberList();
    }
  }, []);

  const getMemberList = async () => {
    try {
      setIsLoading(true);
      const res = (
        await getUserList({
          page: page + 1,
          perPage: DefaultPerPageValue,
          isActive: true,
          filterFields: ['projectUser'],
          filterInputs: [projectId],
        })
      ).data.data;
      setHasMore(res.meta.currentPage !== res.meta.lastPage)
      setMemberList((prevState) => {
        return [...prevState, ...res.data];
      });
      setPage((prevState) => prevState + 1);
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <React.Fragment>
      <Card className="customCard p-3">
        <DashboardCardHeader title={t("Total Team List")} borderBottom="false" fontSize="18px" />
        <div
          style={{
            overflow: memberList.length ? "auto" : "hidden",
          }}
        >

          {/* static data for design testing  */}
          {/* <ul className="teamListing">
                <li>
                  <Avatar
                    {...MemberIcon()}
                  />
                  <div className="teamMember mx-3">
                    <div className="teamPersonName">ucFirst</div>
                    <span className="designation">ucFirst</span>
                  </div>
                </li>
                <li>
                  <Avatar
                    {...MemberIcon()}
                  />
                  <div className="teamMember mx-3">
                    <div className="teamPersonName">ucFirst</div>
                    <span className="designation">ucFirst</span>
                  </div>
                </li>
            </ul> */}
            {/* static data for design testing  */}


          <InfiniteScroll
            dataLength={memberList.length}
            next={getMemberList}
            hasMore={hasMore}
            height={memberList.length ? "560px" : "auto"}
            loader={isLoading && <Loader />}
          >
            <ul className="teamListing">
              {memberList.map((item, index) => (
                <li key={index} className="align-items-center">
                  <UserProfile user={item} profileStyle ={{height: '40px', width: '40px', fontSize: '18px'}}/>
                  <div className="teamMember mx-3">
                    <div className="teamPersonName">{ucFirst(item.name)}</div>
                    {/* <span className="designation">{ucFirst(item?.designation?.name)}</span> */}
                  </div>
                </li>
              ))}
            </ul>
          </InfiniteScroll>

          {!memberList.length && !isLoading && (
            <NodataFound text={t("No members to show")} icon={Member} />
          )}
        </div>
      </Card>
    </React.Fragment>
  );
}

export default withTranslation()(MemberList)
